import Vue from 'vue'
import App from './App.vue'

import vuetify from '@/plugins/vuetify'
import router from '@/plugins/routes'
import store from '@/plugins/store'
import { api } from '@/plugins/api.service'
require('@/plugins/filters.js')

import '@/styles/main.scss'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Wechat from 'vue-wechat'
import flexbox from 'flexboxgrid/dist/flexboxgrid.min.css'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.use(VueAxios, axios)
Vue.use(Wechat)
Vue.use(flexbox)

Vue.wechat.config({
  appId: 'wx5f89682208cf2e87',
  timestamp: '1567086662667',
  nonceStr: 'VDDD7G9VEQPYKEMR',
  signature: '0505918c4aaef4105297578f58e3864f7097fa55'
});

Vue.config.productionTip = false

// Initiaize the $bus
const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $bus: { get: () => EventBus }
});

Vue.use({
  install() {
    Vue.prototype.$api = api
    Vue.prototype.$vuetify = vuetify
  }
})

const app = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

window.__vuetify__ = app
